<template>
    <v-card
        class="mx-auto"
        tile
    >
        <v-navigation-drawer permanent width="100%">

            <v-img
                :src="`http://ckroir.bobruisk.edu.by/ru/sm_full.aspx?guid=6853`"
                :lazy-src="`http://ckroir.bobruisk.edu.by/ru/sm_full.aspx?guid=6853`"
                aspect-ratio="1"
                class="grey lighten-2"
            ></v-img>

        <v-list>


            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="title">Садовская И. Э.</v-list-item-title>
                    <v-list-item-subtitle>Директор «‎ЦКРОиР г. Бобруйска»‎</v-list-item-subtitle>
                    <v-divider class="mt-4 pt-4"></v-divider>
                    <p class="subtitle-2">
                        <b>Телефон/факс:</b> (0225) 78 04 34
                            <br>
                        <b>Телефон:</b> (0225) 78 66 85
                    </p>
                </v-list-item-content>
            </v-list-item>

        </v-list>

        <v-divider></v-divider>

        <v-list-item-title class="title subtitle-2 pa-md-4">Популярные разделы:</v-list-item-title>
        <v-list
            dense
            nav
        >
            <v-list-item
                v-for="(item, i) in sidebarLinks"
                :key="i"
                link
            >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>

            <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
            </v-list-item>
        </v-list>


        <v-carousel
            cycle
            height="150"
            hide-delimiter-background
            show-arrows-on-hover
        >
            <v-carousel-item
                v-for="(slide, i) in slides"
                :key="i"
            >
                <v-sheet
                    :color="colors[i]"
                    height="100%"
                    tile
                >

                        <div class="subtitle-2 pa-4">{{ slide }} </div>
                    
                </v-sheet>
            </v-carousel-item>
        </v-carousel>


        <v-list-item>
            <v-list-item-content>

                <p class="subtitle-2">
                    Обратите внимание:
                </p>
                <p class="caption"><a href="http://dadomu.by/" target="_blank">DADOMU.BY</a>- портал, объединяющий разных людей в поиске семьи для каждого ребёнка</p>
                <p class="caption"><a href="https://edu.gov.by/god-maloy-rodiny/" target="_blank">EDU.GOV.BY</a> - 2018-2020 год - Год малой родины</p>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item>
            <v-list-item-content>

                <p class="subtitle-2">
                    Поделиться в соц. сетях:
                </p>

                <social-sharing url="https://vuejs.org/"
                    title="Центр коррекционно-развивающего обучения и реабилитации г. Бобруйска"
                    description="Это учреждение специального образования, в котором осуществляется обучение и воспитание детей с тяжелыми и (или) множественными физическими и (или) психическими нарушениями."
                    quote="Учреждение специального образования."
                    hashtags="ЦКРОиР, Бобруйск"
                    twitter-user="vuejs"
                    inline-template
                >
                    <div>

                        <network network="vk">
                            + ВКонтакте
                        </network>

                        <br>

                        <network network="odnoklassniki">
                            + Одноклассники
                        </network>

                        <br>

                        <network network="facebook">
                            + Facebook
                        </network>

                    </div>
                </social-sharing>


            </v-list-item-content>
        </v-list-item>
        </v-navigation-drawer>
    </v-card>
</template>

<script>
	export default {
		data: function() {
			return {
				sidebarLinks: [
					{ text: 'Как нас найти', icon: 'mdi-map-search' },
					{ text: 'Эл. обращение', icon: 'mdi-pen' },
					{ text: 'Норм. прав. документы', icon: 'mdi-file-document-outline' },
				],

				colors: [
				'indigo',
				'warning',
				'pink darken-2',
				],

				slides: [
				'«Учитель, образ его мыслей — вот что самое главное во всяком обучении и воспитании.« (Дистервег А.)',
				'«Кто знает все, тому еще многому нужно учиться.» (Славомир Врублевский)',
				'«Чтобы научить другого, требуется больше ума, чем чтобы научиться самому...» (М. Монтень)',
				],
			}
		}
	}
</script>

<style>
	
</style>